var _path;

var _excluded = ["title", "titleId"];

function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import * as React from "react";

function SvgActive(_ref, svgRef) {
  var title = _ref.title,
      titleId = _ref.titleId,
      props = _objectWithoutProperties(_ref, _excluded);

  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 24,
    height: 24,
    viewBox: "0 0 24 24",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M13.7321 18.0006C13.3862 18.5981 12.7401 19 12 19C11.26 19 10.6138 18.5981 10.2679 18.0006H13.7321ZM12 5.00001C12.5523 5.00001 13 5.44773 13 6.00001L13.0001 6.10509C15.0465 6.54168 16.6206 8.29117 16.765 10.4579L16.9909 13.8463L18.4288 16.2428C18.6287 16.576 18.3887 17 18 17H6.00004C5.61139 17 5.37134 16.576 5.57129 16.2428L7.00918 13.8463L7.23507 10.4579C7.3795 8.29139 8.95327 6.54204 10.9993 6.10523L11 6.00001C11 5.44773 11.4478 5.00001 12 5.00001ZM20.6159 2.67992C20.7927 2.46778 21.108 2.43912 21.3201 2.6159C21.5323 2.79268 21.5609 3.10797 21.3842 3.3201L18.8842 6.3201C18.6959 6.54597 18.3544 6.56147 18.1465 6.35357L17.1465 5.35357C16.9512 5.1583 16.9512 4.84172 17.1465 4.64646C17.3417 4.4512 17.6583 4.4512 17.8536 4.64646L18.4664 5.25931L20.6159 2.67992Z",
    fill: "currentColor"
  })));
}

var ForwardRef = /*#__PURE__*/React.forwardRef(SvgActive);
export default __webpack_public_path__ + "static/media/active.d9e4191e90d85adf262ebbcc852a6649.svg";
export { ForwardRef as ReactComponent };